import script from "./ProjectHeaderSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectHeaderSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./ProjectHeaderSwitcher.vue?vue&type=style&index=0&id=059421fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059421fb"]])

export default __exports__